import React, { useEffect } from "react";
import { BrowserRouter, Link, Route, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import useNavigateToSection from "../hooks/useNavigateToSection";

const Work1: React.FC = () => {
  window.scrollTo(0, 0);
  const navigateToSection = useNavigateToSection();
  return (
    <main className="content pt-40">
      <Container>
        <article className="article mx-auto">
          <div className="article-container">
            <h2 className="article-title text-center text-3xl font-bold mb-4">
              Be Pretty | E-commerce website
            </h2>
            <div className="article-body grid gap-y-5">
              <div className="flex justify-center">
                <img
                  src="/be-pretty.png"
                  alt=""
                  className="mb-4 max-h-[50rem] object-contain"
                />
              </div>
              <p className="mt-3">
                An online web application where you can purchase beauty products
                such as cosmetics and skincare, or view detailed information
                about beauticians and bookmark your favorites.
              </p>
              <ul className="flex gap-x-3 flex-wrap gap-y-2">
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Next.js 13
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  React.js
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  TypeScript
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Tailwind
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Prisma
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  DaisyUI
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Responsive Design
                </li>
              </ul>
              <div>
                <h3 className="font-bold mb-2 text-xl">URL</h3>
                <p className="mb-4">
                  <a
                    href=" https://be-pretty-liard.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://be-pretty-liard.vercel.app/
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">Github Repo</h3>
                <p className="mb-4">
                  <a
                    href="https://github.com/Mizuki-Kawabe/be-pretty"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://github.com/Mizuki-Kawabe/be-pretty
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">My role</h3>
                <p className="mb-4">Design, Frontend coding</p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">Project Purpose</h3>
                <p className="mb-4">
                  It aimed to create a website for brand recognition and enable
                  users to purchase products and check beauticians.
                </p>
                <p className="mb-4">
                  To immediately show visitors what be pretty can do, I featured
                  some products and beauticians on the home screen.
                </p>
                <p className="mb-4">
                  I crafted buttons and UX motions to ensure a smooth journey
                  for the user's conversion.
                </p>
              </div>
              <div className="">
                <h3 className="font-bold mb-2 text-xl">
                  Problems I faced & Lessons Learned
                </h3>
                <div className="grid gap-y-3">
                  <li className="mb-2">
                    Overusing UI libraries resulted in limitations on design
                    customization and issues when combined with other libraries.
                    <br />I learned that it's crucial to consider compatibility
                    with the programming language and be cautious when using
                    multiple UI libraries.
                  </li>
                  <li>
                    While coding with references from the web and the internet,
                    I encountered errors even with the same code due to
                    differing site references, UI library, and programming
                    language versions. <br />
                    This taught me the importance of checking versions and
                    primarily referencing official sites and documents to follow
                    their rules for coding.
                  </li>
                  <li>
                    Using react slick for a slider significantly slowed down the
                    website's loading speed. <br />
                    Identifying the cause early when page load times increased
                    and using a different tool improved speed.
                  </li>
                  <li>
                    Designing with a unified atmosphere in mind was challenging,
                    requiring careful consideration of fonts and color schemes.
                    <br />I researched about 30 beauty and booking sites,
                    incorporating designs I liked. As a beauty web app, I used
                    warm colors like pink and yellow, adding pastel colors such
                    as blue and green for accents.
                  </li>
                </div>
              </div>
            </div>

            <button
              className="font-bold block mx-auto my-10 h-color"
              onClick={() => navigateToSection("works")}
            >
              ← Go back to Works
            </button>
          </div>
        </article>
      </Container>
    </main>
  );
};

export default Work1;
